const API_NAMESPACE = 'cmsAPI';

export const globalAPI = {
  add
};

function add(apiName, apiModule) {
  if (!isAttachedToWindow()) {
    window[API_NAMESPACE] = {};
  }

  window[API_NAMESPACE][apiName] = apiModule;
}

function isAttachedToWindow() {
  return !!window[API_NAMESPACE];
}



// WEBPACK FOOTER //
// ./src/js/api/globalAPI.js